module.exports = __webpack_public_path__ + "static/img/d7t_pc.c8e7dbef.jpg";